import { render, staticRenderFns } from "./MechanicAssetPage.vue?vue&type=template&id=21b60b79&scoped=true&"
import script from "./MechanicAssetPage.vue?vue&type=script&lang=js&"
export * from "./MechanicAssetPage.vue?vue&type=script&lang=js&"
import style0 from "./MechanicAssetPage.vue?vue&type=style&index=0&id=21b60b79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b60b79",
  null
  
)

export default component.exports